import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Address, ListParams, OrganizationInfo, PaginationInput, PaginationPageEvent, Res, UserList } from 'src/app/models';
import { ApiOrganizationsService, ApiUsersService, FilesService, LanguageService } from 'src/app/services';

@Component({
  selector: 'app-organization-profile',
  templateUrl: './organization-profile.component.html',
  styleUrls: ['./organization-profile.component.css']
})
export class OrganizationProfileComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  organization: OrganizationInfo;
  orgId: string;
  employees: UserList[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  tableData = [
    { id: 0, name: 'name' },
    { id: 1, name: 'role' },
    { id: 2, name: 'action' }
  ]

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiOrganizations: ApiOrganizationsService,
    private currentRoute: ActivatedRoute,
    private router: Router,
    private apiUsers: ApiUsersService,
    private fileService: FilesService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.orgId = this.currentRoute.snapshot.paramMap.get('id');

    this.onInfo();
    this.getListEmployees();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  onInfo(): void {

    this.progressRef.start();
    this.loading = true;
    this.organization = null;

    this.apiOrganizations.info(this.orgId).subscribe((response: Res) => {
      console.log("ORG_PROFILE: ", response);


      if (response != null) {

        if (response.result != null) {

          this.organization = response.result;

          if (this.organization.addresses != null) this.organization.addresses = this.apiOrganizations.sortAddress(this.organization.addresses);

          this.getImageContent(response.result);

        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }


  /**
   * 
   * @param address Address
   * @returns string
   */
  addressObjToString(address: Address): string {

    return this.apiOrganizations.addressObjToString(address);
  }


  /**
   * 
   */
  getListEmployees(): void {

    this.progressRef.start();
    this.loading = true;
    this.employees = [];

    this.setListParams();

    this.apiUsers.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] get list employees: ', response);

      if (response != null) {

        this.employees = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        org_id: this.orgId
      },
      object: 'orgs_users',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
  * 
  * @param product Product
  */
  getImageContent(organization: any): void {

    if (organization.logo_pic && organization.logo_pic != null) {

      this.subscriptions.add(
        this.fileService.getImageContent(organization.logo_pic).subscribe((response: any) => {

          if (response != null) {

            organization['logo_pic'] = response.result;
          }
        })
      );
    }
    if (organization.background_pic && organization.background_pic != null) {

      this.subscriptions.add(
        this.fileService.getImageContent(organization.background_pic).subscribe((response: any) => {

          if (response != null) {

            organization['background_pic'] = response.result;
          }
        })
      );
    }
  }


  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getListEmployees();
  }

  backTo(id: string) {

    this.router.navigate(['organizations', 'profile', this.orgId]);

  }

  isEmptyObject(value){

    return Object.keys(value).length === 0;
  }
}
